import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataType } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataType,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Interpreta la tirada de cartas para la lectura de ex pareja que realizaste para ${
        data.consultante.name
    } con número de personalidad ${data.consultante.personality} y ${data.consultado.name} con número de personalidad ${
        data.consultado.personality
    } según el siguiente esquema: ${formatCardLabel(cards[0])} para la energía actual del consultante, ${formatCardLabel(cards[1])} para la energía actual del consultado (ex), ${formatCardLabel(cards[2])} para la lección del vínculo, ${formatCardLabel(cards[3])} para la conexión energética actual, ${formatCardLabel(cards[4])} para lo que los une en este momento, ${formatCardLabel(cards[5])} para los obstáculos o diferencias que existen entre ambos, ${formatCardLabel(cards[6])} para las posibilidades reales de reencuentro según las cartas (sin prejuzgar ni forzar un cierre), ${formatCardLabel(cards[7])} para lo que el consultante necesita trabajar o integrar, ${formatCardLabel(cards[8])} para el consejo del Ser Superior/Universo y ${formatCardLabel(cards[9])} para el resultado probable si las energías actuales no se modifican. 
      
      Interpreta cada posición de forma fiel a las cartas. No asumas de antemano que el vínculo debe cerrarse. Si las cartas muestran posibilidad de reencuentro, díselo con claridad. Si muestran cierre o distancia, también. Sé honesta y directa según lo que las cartas indiquen.
      
      Con el resto de las cartas: ${formatCardLabel(cards[10])}, ${formatCardLabel(cards[11])}, ${formatCardLabel(cards[12])} y ${formatCardLabel(cards[13])} ${
          data.consulta.length > 0
              ? 'utilizalas para responder las preguntas del consultante, siempre en coherencia con la lectura principal de las 10 cartas anteriores: ' +
                data.consulta
              : 'utilizalas para ampliar y matizar el resultado probable'
      }. No hagas una enumeración de las cartas, sino un desarrollo de la lectura mencionándolas en ese desarrollo. Dirígete directamente al consultante. ${
          data.consultado.personality !== undefined
              ? 'También haz una breve reseña de la compatibilidad entre ambos según su número de personalidad numerológico.'
              : ''
      }`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer:
            'Consulta uno: ' +
            data.consulta +
            '. Consulta dos:  ' +
            data.consulta +
            '. Consulta tres: ' +
            data.consulta,
        cards,
        type,
    }

    return info
}
